/**
 * Accent palettes, written onto `<html data-palette>` and read by
 * theme/design.css.
 *
 * `ki` is the KeepInvesting green the marketing site uses, and it is the base
 * `:root` accent rather than a `[data-palette]` override — so it is also what
 * an unrecognised stored value falls back to, in the store and in the CSS.
 */
export const PALETTES = [
  ['ki', 'KeepInvesting Green'],
  ['royal', 'Royal Blue'],
  ['plum', 'Plum'],
  ['bronze', 'Bronze'],
  ['rose', 'Rose'],
  ['neon', 'Neon Green'],
];

export const DEFAULT_PALETTE = 'ki';

/** Keeps a retired palette (the old indigo default) from leaving the picker blank. */
export const isPalette = (value) => PALETTES.some(([key]) => key === value);
